<template>
  <span class="err-msg text-red-2 l-0">
    <i class="fas fa-exclamation-circle mr-xs"></i>
    <span v-text="msg"></span>
  </span>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default: "This field is required"
    }
  }
};
</script>

<style lang="stylus" scoped></style>
